export default "__VITE_ASSET__DgGI3R4k__"